export function isNotUndefined<T>(item: T | undefined): item is T {
    return item !== undefined;
}

export function isNotNull<T>(item: T | null): item is T {
    return item !== null;
}

export function isPresent<T>(item: T | undefined | null): item is T {
    return item !== undefined && item !== null;
}
